/* eslint-disable no-console */
import { Workbox } from "workbox-window";

let wb;
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    wb = new Workbox(`${process.env.VUE_APP_SITE_BASE_PATH}service-worker.js`);

    let refreshing = false;
    wb.addEventListener("controlling", () => {
        if (refreshing) return;
        // Recargar mientras se esta completando el login con Cognito vuelve a
        // cargar /callback con el mismo `code`, que es de un solo uso: el
        // segundo intercambio falla y el usuario se queda sin sesion.
        if (window.location.pathname.endsWith("/callback")) return;
        refreshing = true;
        window.location.reload();
    });

    wb.register();
} else {
    wb = null;
}

export default wb;
